module.exports = __webpack_public_path__ + "img/pen.ac6d15c8.svg";